import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import ivrsTreeDataResource from 'src/actions/ivrs/ivrsTreeDataResource';
import { IvrNodePosition } from 'src/models/Ivrs/IvrTreeData';

const useTreeNodesPositions = ({ id, version }) => {
  const dispatch = useDispatch();
  const [locationState, setLocationState] = useState<IvrNodePosition>();
  const { replace } = ivrsTreeDataResource.effects;
  const [currentId, setCurrentId] = useState<string>();
  const [currentVersion, setCurrentVersion] = useState<number>(0);

  useEffect(() => {
    setCurrentVersion(version);
    setCurrentId(id);
  }, [id, setCurrentVersion, setCurrentId, version]);

  const updateLocations = locations => {
    const newState: any = {
      ...locationState,
      ...locations,
    };

    dispatch(
      replace(
        { id: currentId, version: currentVersion },
        { id: currentId, version: currentVersion, positions: newState }
      )
    );
    setLocationState(newState);
  };

  return { locationState, setLocationState, updateLocations };
};

export default useTreeNodesPositions;
